module.exports = __webpack_public_path__ + "images/blue-chevron-17b76ae4.svg";